<template>
  <v-row no-gutters>
    <v-col cols="12">
      <field-label :field="field"></field-label>

      <v-text-field
        :value="value"
        :rules="rules"
        :disabled="field.disabled"
        @input="input"
        outlined
        clearable
        dense
        @click="dialog = true"
        :style="textFieldStyle"
      ></v-text-field>

      <div
        v-if="showPreview && (isImage || isVideo)"
        class="mb-6 checkered-background"
        style="max-width: 200px;"
      >
        <v-img
          :src="loadMedia(value, 'sm')"
          :lazy-src="loadMedia(value, 'thumbnail')"
          contain
          v-if="isImage"
        ></v-img>

        <video controls v-if="isVideo">
          <source :src="value" />
        </video>
      </div>

      <v-dialog v-model="dialog" width="1600" scrollable>
        <media-manager-card
          :isDialog="true"
          @insertItem="insertItem"
          @closed="dialog = false"
          :allowedTypes="field.allowedTypes || ['image']"
        ></media-manager-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import MediaManagerCard from '@/components/editor/types/MediaManager/MediaManagerCard'
import FieldLabel from '@/components/editor/partials/FieldLabel'

export default {
  name: 'TextField',
  props: { value: {}, field: {}, showPreview: { default: true } },
  data: () => ({
    dialog: false
  }),
  components: {
    MediaManagerCard,
    FieldLabel
  },
  computed: {
    textFieldStyle() {
      return {
        marginBottom: this.isImage || this.isVideo ? '-15px' : 0
      }
    },
    isImage() {
      return (
        this.value != null && this.value.match(/\.(jpeg|jpg|gif|png)$/) != null
      )
    },
    isVideo() {
      return (
        this.value != null &&
        this.value.match(/\.(mp4|avi|mov|webm|ogv)$/) != null
      )
    },
    rules() {
      let rules = this.field.rules || []

      return rules.map(rule => this.$store.state.editor.validation.rules[rule])
    }
  },
  methods: {
    input(value) {
      this.$emit('update:value', value)
    },
    setDefaultValue() {
      // TODO - fix default value set up
      // if (this.value === undefined && this.field.default !== undefined) {
      //   this.input(this.field.default)
      // }
    },
    insertItem(item) {
      this.$emit('update:value', item)
      this.dialog = false
    },
    deleteItem() {
      this.$emit('update:value', null)
    }
  },
  mounted() {
    this.setDefaultValue()
  }
}
</script>
